<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <h2>Vue Community Coming Soon!</h2>
    <a href="/api/srvrlss">Serverless</a>
  </div>
</template>

<script>
export default {
  name: 'app',
  
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
